import {createSelector} from 'reselect';
import {getSelectedDeliveryCountry, getSettings} from './selectors';

export default createSelector(
  [getSettings, getSelectedDeliveryCountry],
  (settings, country) => !!settings.tax_engine_subdivision_countries?.includes(country),
);
